module.exports = __webpack_public_path__ + "files/f6e91eca60c68a8c5bc10b700bae45b8.png";